import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import styles from './header.module.css';
import constants from '../../../constants';

import { useLeagueTypeProvider } from '../../../providers/LeagueTypeProvider';

const Header = ({toggleSidebar, selectedPage}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { leagueType } = useLeagueTypeProvider();

  const changePages = (e) => {
    navigate("/" + e.currentTarget.id, { replace: true });
  }

  return (
    <div className={styles.Header}>
      <div style={{height:'100%', display: 'flex', alignItems:'center', justifyContent:'flex-start'}}>
        <div className={styles.Hamburger} onClick={toggleSidebar}><img style={{height: '100%', width: '100%'}} src="/icons/hamburger.svg"/></div>
        <div className={styles.Logo}><img src="/icons/cpl-logo.svg" style={{height: '100%', width: '100%'}} onClick={(e) => changePages(e, true)}/></div>
      </div>

      <div style={{height:'100%', display: 'flex', alignItems:'center', justifyContent:'flex-end', maxWidth: '50%', minWidth: '35%'}}>
        <div className={styles.Nav}>
            <div className={styles.NavItemWrapper}>
            <div className={`${styles.NavItem} ${pathname.includes(constants.registration) ? styles.SelectedItem : ""}`} >{constants.header.registration}</div>
                <div className={styles.SubMenu}>
                    <div id={constants.pages.clubRegistration} className={styles.SubMenuItem} onClick={(e) => changePages(e)}>{constants.header.clubRegistration}</div>
                    <div id={constants.pages.playerRegistration} className={styles.SubMenuItem} onClick={(e) => changePages(e)}>{constants.header.playerRegistration}</div>
                    <div id={constants.pages.localRegistration} className={styles.SubMenuItem} onClick={(e) => changePages(e)}>{constants.header.localRegistration}</div>
                </div>
            </div>

          <div className={styles.NavItemWrapper}>
            <div className={`${styles.NavItem} ${pathname.includes(constants.pages.leagues) ? styles.SelectedItem : ""}`} >{constants.header.leagues}</div>
            <div className={styles.SubMenu}>
              <div id={constants.pages.leagues} className={styles.SubMenuItem} onClick={(e) => changePages(e)}>{constants.header.crossClubLeague}</div>
              <div id={constants.pages.genderLeagues} className={styles.SubMenuItem} onClick={(e) => changePages(e)}>{constants.header.genderLeague}</div>
              <div id={constants.pages.localLeagues} className={styles.SubMenuItem} onClick={(e) => changePages(e)}>{constants.header.localLeague}</div>
              <div className={styles.SubMenuItem} onClick={() => {window.open(constants.externalLinks.ladderLeague, '_blank', 'noopener,noreferrer')}}>{constants.header.ladderLeague}</div>
            </div>
          </div>
        
          <div id={constants.pages.aboutUs} className={`${styles.NavItem} ${pathname.includes(constants.pages.aboutUs) ? styles.SelectedItem : ""}`} onClick={(e) => changePages(e)}>{constants.header.aboutUs}</div>
          <div className={styles.NavItemWrapper}>
            <div className={`${styles.NavItem} ${pathname.includes(constants.pages.contactUs) ? styles.SelectedItem : ""}`} >{constants.header.contactUs}</div>
            <div className={styles.SubMenu}>
              <div id={constants.pages.contactUs} className={styles.SubMenuItem} onClick={(e) => changePages(e)}>{constants.header.contactUs}</div>
              <div id={constants.pages.incidentReport} className={styles.SubMenuItem} onClick={(e) => changePages(e)}>{constants.header.incidentReport}</div>
            </div>
          </div>
        </div>

        <div className={styles.NavItem}>
          <div className={styles.Shop}>
            <img src='/icons/shop.svg'
                style={{height: '100%', width: '100%'}}
                onClick={() => {window.open(constants.externalLinks.cplShop, '_blank', 'noopener,noreferrer')}}/>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Header;
